import React, { Fragment } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { connect } from 'react-redux'
import { getLang } from 'utils/getLang'

// utils
import { getURLSearchParams } from 'utils/getURLSearchParams'
import Selector from 'components/PageItems/components/Selector'


const ItemsList = (props) => {
  let { items, getMapIdKey, unwind, unwindNewField, component, componentHeaderList, tableClassName, fnConfigItems, lang } = props
  const CompHeaderList = componentHeaderList
  const CompList = component
  const urlParams = new URLSearchParams(props.location.search)

  let pageNo = urlParams.get('current_page') || 1
  pageNo = parseInt(pageNo)

  let useSelect = getURLSearchParams(location.search)
  useSelect = useSelect && useSelect.useSelector && useSelect.useSelector === "true"

  if (fnConfigItems) {
    items = fnConfigItems(items)
  }

  const getMapKey = (_id) => {
    let keyValue = ''

    for (let key in _id) {
      keyValue = `${keyValue}${_id[key]}`
    }

    return keyValue
  }

  return (
    <Fragment>
      { useSelect &&
        <Selector {...props} pageNo={pageNo} useSelect={useSelect} />
      }

      { !props.notItemListTable ?
        <table className={`table-list ${tableClassName || ''}`}>

          { items.lenght !== 0 && CompHeaderList && <CompHeaderList /> }

          <ReactCSSTransitionGroup
            id="blockUnSelectItems"
            component="tbody"
            transitionName="example"
            transitionEnterTimeout={1000}
            transitionLeaveTimeout={1000}>

            { items && items.map((data, i) => {
              let key

              if (getMapIdKey) {
                key = getMapKey(data._id)
              } else if (unwindNewField) {
                key = data[unwindNewField] && data[unwindNewField]._id
              } else if (unwind) {
                key = data[unwind] && data[unwind]._id
              } else {
                key = data._id
              }

              return (
                <CompList
                  {...props}
                  useSelect={useSelect}
                  pageNo={pageNo}
                  key={key}
                  data={data}
                />
              )
            }) }

          </ReactCSSTransitionGroup>
        </table>
      :
        <ReactCSSTransitionGroup
          id="blockUnSelectItems"
          component="div"
          transitionName="example"
          transitionEnterTimeout={1000}
          transitionLeaveTimeout={1000}>

          { items && items.map((data, i) => {
            let key

            if (getMapIdKey) {
              key = getMapKey(data._id)
            } else if (unwind) {
              key = data[unwind]._id
            } else {
              key = data._id
            }

            return (
              <CompList
                {...props}
                useSelect={useSelect}
                pageNo={pageNo}
                key={key}
                data={data}
              />
            )
          }) }
        </ReactCSSTransitionGroup>
      }
    </Fragment>
  )
}

const mapStateToProps = (state, props) => {
  return {
    lang: getLang({ state, props }).lang
  }
}

export default connect(mapStateToProps)(ItemsList)
